export enum VERTICAL_NAMES {
  SODEXO = 'sodexo-wallet',
  WALLET = 'wallet',
}
